"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { getFormula } from '@membranehq/sdk';
import { useFormulaComponents } from '../../DataBuilder/Formula/use-formula-components.mjs';
import { forwardRef } from 'react';
import NoUiFormula from '../../DataBuilder/Formula/noUi.mjs';

const ComboBoxFormulaBadge = forwardRef(
  ({ value, ...props }, ref) => {
    const formulaComponentMapping = useFormulaComponents();
    const formula = getFormula(value);
    if (!formula) {
      return /* @__PURE__ */ jsx(NoUiFormula, {});
    }
    const formulaMapping = formulaComponentMapping[formula.type];
    if (!formulaMapping?.component) {
      return /* @__PURE__ */ jsx(NoUiFormula, {});
    }
    const FormulaComponent = formulaMapping.component;
    return /* @__PURE__ */ jsx(FormulaComponent, { ...props, formula, ref });
  }
);
ComboBoxFormulaBadge.displayName = "ComboBoxFormulaValue";

export { ComboBoxFormulaBadge };
